<script>
export default {}
</script>

<template>
  <div class="loading" style="min-height:200px;"></div>
</template>
